import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import About from "./pages/About";
import PrivacyPolicy from "./pages/Privacy";
import TermsOfService from "./pages/Terms";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route exact={true} path="/" element={<Home />} />
          <Route exact={true} path="/services" element={<Services />} />
          <Route exact={true} path="/projects" element={<Projects />} />
          <Route exact={true} path="/about" element={<About />} />
          <Route exact={true} path="/contact" element={<Contact />} />
          <Route exact={true} path="/privacy" element={<PrivacyPolicy />} />
          <Route exact={true} path="/terms" element={<TermsOfService />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      ;
    </>
  );
}

export default App;
